module.exports = __webpack_public_path__ + "static/LogoCbimPaint-2b3966c17e59da87703f1ad1d10a1880.png";